<template>
    <!-- 酒店管理 -->
    <div class="siteManagement_main" :class="{'cn':version == '1'}">
        <div class="siteManagement_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="siteManagement_right">
            <div class="siteManagement_right_l">
                <div class="btn_box">
                    <div class="btn" @click="addHotel(0)"><img :src="img_new_hotel"><span>{{$t('App.siteManagement.text1')}}</span></div>
                    <div class="btn" @click="addHotel(1)" v-if="version == '1'"><img :src="img_new_hotel"><span>{{$t('App.siteManagement.text2')}}</span></div>
                </div>
                <div class="ul scrollbar_style scrollbar_style_show">
                    <div class="li" :class="{'select':hotelId == item.id}" v-for="item in hotelNavList" :key="item.id" @click="hotelSelectFun(item)">
                        <div class="li_box1">
                            <div class="li_box1_l">
                                <div class="img_box">
                                    <img :src="item.avatar">
                                </div>
                                <div class="text_box" :title="item.name"><span>{{item.name}}</span></div>
                            </div>
                            <div class="icon_box" v-show="hotelId == item.id">
                                <i class="iconfont icon-bianji" @click.stop="editHotel(item)"></i>
                                <i class="iconfont icon-delete" @click.stop="postDelHotel(item)"></i>
                            </div>
                        </div>
                        <div class="li_box2">
                            <p>{{item.location}}</p>
                        </div>
                        <div class="li_box3">
                            <div class="li_box3_l">{{$t('App.room.text1')}}</div>
                            <div class="li_box3_r">{{item.roomCount}}</div>
                        </div>
                        <div class="border"></div>
                    </div>
                </div>
            </div>
            <div class="siteManagement_right_main">
                <div class="main_top">
                    <div class="div1">
                        <div class="div1_l">
                            <el-dropdown @command="commandbuild" trigger="click" @visible-change="commandHide('dropdown_hotel_build')">
                                <span class="span1" v-loading="loading.buildNav">{{buildName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                                <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_build">
                                    <el-dropdown-item v-for="item in buildNav" :command="item" :key="'build'+item.id" :class="{'select':item.id == buildId}">
                                        <span>{{item.name}}</span>
                                        <i class="iconfont icon-bianji" @click.stop="eidtBuild(item)"></i>
                                        <i class="iconfont icon-delete" @click.stop="postDelBuild(item)"></i>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="div1_r">
                            <div class="btn" @click="linkToFun('/circadianLightsPlan')"><span>{{$t('App.siteManagement.text3')}}</span></div>
                            <div class="btn" @click="addBuild()"><img :src="img_new_building"><span>{{$t('App.siteManagement.text4')}}</span></div>
                            <div class="btn" @click="addFloor()"><img :src="img_new_floor"><span>{{$t('App.siteManagement.text5')}}</span></div>
                        </div>
                    </div>
                    <div class="div2" :class="{'hide_left_btn':floorIndex>0}">
                        <div class="l_btn" @click="floorIndexFun('-')" v-if="floorIndex>0">
                            <i class="el-icon-caret-left"></i>
                        </div>
                        <div class="ul_box">
                            <div class="ul" :style="{left:floorIndex*-100+'%'}">
                                <div class="li" :class="{'select':floorId == item.id}" v-for="item in floorNav" :key="item.id" @click="floorSelectFun(item)">
                                    <span>{{item.name}}</span>
                                    <!-- <i class="iconfont icon-delete" v-if="floorId == item.id" @click.stop="postDelFloor(item)"></i> -->
                                </div>
                            </div>
                        </div>
                        <div class="r_btn" @click="floorIndexFun('+')">
                            <i class="el-icon-caret-right"></i>
                        </div>
                    </div>
                    <div class="div3">
                        <div class="div3_l">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="delRoom(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                        </div>
                        <div class="div3_r">
                            <div class="btn" @click="addRoom()"><img :src="img_new_room"><span>{{$t('App.siteManagement.text6')}}</span></div>
                            <div class="btn" @click="editFloor()"><i class="iconfont icon-bianji"></i><span>{{$t('App.siteManagement.text7')}}</span></div>
                            <div class="btn" @click="postDelFloor()"><i class="iconfont icon-delete1"></i><span>{{$t('App.siteManagement.text8')}}</span></div>
                        </div>
                    </div>
                </div>
                <div class="main_cont">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                        <el-table
                            ref="roomList"
                            v-loading="loading.roomList"
                            element-loading-background="rgba(0, 0, 0, 0.5)"
                            height="100%"
                            :data="roomList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                align="left"
                                header-align="center"
                                :width="100">
                                <template slot-scope="scope">
                                    <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in roomArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">
                                    <template slot-scope="scope">
                                        <div v-if="item.type != 1">{{scope.row[item.prop]}}</div>
                                        <!-- <div v-if="item.prop == 'activites'" class="activites">
                                            <span :class="'text_'+scope.row[item.prop]">{{activitesArr[scope.row[item.prop]]}}</span>
                                        </div> -->
                                    </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :min-width="100"
                                :label="$t('App.lights.text6')">
                                <template slot-scope="scope">
                                    <span class="btn" @click="editRoom(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-bianji"></i>
                                    </span>
                                    <span class="btn" @click="settingRoom(scope.row)" :title="$t('App.airPurifiers.text1')">
                                        <i class="iconfont icon-setting"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <!-- <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- 酒店新增编辑 -->
        <div class="hotel_wrap tk_wrap scrollbar_style" v-show="hotelTkShowbg">
            <div class="tk_wrap_bg" @click="hotelTkClose()"></div>
            <div class="tk_box" :class="{'tk_show':hotelTkShow}" v-loading="loading.hotelInfo">
                <div class="tk_title">
                    <span class="span1">{{hotelTitle}}</span>
                    <span class="span2" @click="hotelTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        name="file"
                        :data="imgUploadData"
                        :action="actionImgUrl"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="hotelForm.avatar" :src="hotelForm.avatar" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <img class="phone_icon" src="../img/phone_icon.png" />
                    </el-upload>
                    <div class="form_item">
                        <span class="laber">{{$t('App.name')}}</span>
                        <el-input v-model="hotelForm.name" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.header.text2')}}</span>
                        <el-dropdown @command="commandCountry" trigger="click" @visible-change="commandHide('dropdown_hotel_country')">
                            <span class="span1">{{hotelFormCountryName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_country">
                                <el-dropdown-item v-for="item in countryList" :command="item" :key="'country'+item.id" :class="{'select':item.id == hotelForm.countryId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item" v-if="hotelFormProvinceName">
                        <span class="laber">{{$t('App.header.text3')}}</span>
                        <el-dropdown @command="commandProvince" trigger="click" @visible-change="commandHide('dropdown_hotel_province')">
                            <span class="span1">{{hotelFormProvinceName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_province">
                                <el-dropdown-item v-for="item in provinceList" :command="item" :key="'province'+item.id" :class="{'select':item.id == hotelForm.provinceId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item"  v-if="hotelFormCityName">
                        <span class="laber">{{$t('App.header.text4')}}</span>
                        <el-dropdown @command="commandCity" trigger="click" @visible-change="commandHide('dropdown_hotel_city')">
                            <span class="span1">{{hotelFormCityName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_city">
                                <el-dropdown-item v-for="item in cityList" :command="item" :key="'city'+item.id" :class="{'select':item.id==hotelForm.cityId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.siteManagement.text11')}}</span>
                        <el-input v-model="hotelForm.address" placeholder=""></el-input>
                    </div>
                    <div class="form_item" style="width: calc(100% - 11rem)">
                        <span class="laber">{{$t('App.siteManagement.text12')}}</span>
                        <el-input v-model="hotelForm.longitude" placeholder=""></el-input>
                    </div>
                    <div class="form_item" style="width: calc(100% - 11rem);position: relative;">
                        <span class="laber">{{$t('App.siteManagement.text13')}}</span>
                        <el-input v-model="hotelForm.latitude" placeholder=""></el-input>
                        <div class="location" @click="amapWrapperFun()"><i class="iconfont icon-weizhilanse"></i></div>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveHotel()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>
        <el-dialog
          width="80%"
          title="hotel positioning"
          :visible.sync="amapWrapper"
          :close-on-click-modal="false"
          class="lampAmapWrapper_dialog">
          <div class="lampAmapWrapper_box">
                <el-input class="screenMap" v-model="screenMap" @keyup.native="screenMapKeyUp($event)" :placeholder="$t('App.placeholder.text4')" clearable>
                 <i slot="prefix" class="scree-icon el-icon-search" @click="screenMapChange(screenMap)"></i>
                </el-input>
              <div id="lampAmapWrapper">
              </div>
          </div>
        </el-dialog>
        <div class="build_wrap tk_wrap scrollbar_style" v-show="buildTkShowbg">
            <div class="tk_wrap_bg" @click="buildTkClose()"></div>
            <div class="tk_box" :class="{'tk_show':buildTkShow}">
                <div class="tk_title">
                    <span class="span1">{{buildTkTitle}}</span>
                    <span class="span2" @click="buildTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        name="file"
                        :data="imgUploadData"
                        :action="actionImgUrl"
                        :on-success="buildFormSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="buildForm.image" :src="buildForm.image" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <img class="phone_icon" src="../img/phone_icon.png" />
                    </el-upload>
                    <div class="form_item">
                        <span class="laber" v-if="domainName != 'plant'">{{$t('App.header.text5')}}</span>
                        <span class="laber" v-if="domainName == 'plant'">{{$t('App.header.text6')}}</span>
                        <el-dropdown @command="commandBuildFormHotel" trigger="click" @visible-change="commandHide('dropdown_hotel_build_hotel')">
                            <span class="span1">{{buildFormHotelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_build_hotel">
                                <el-dropdown-item v-for="item in hotelNavList" :command="item" :key="'hotel_'+item.id" :class="{'select':item.id == buildForm.hotelId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.siteManagement.text15')}}</span>
                        <el-input v-model="buildForm.name" placeholder=""></el-input>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveBuild()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>
        <div class="floor_wrap tk_wrap scrollbar_style" v-show="floorTkShowbg">
            <div class="tk_wrap_bg" @click="floorTkClose()"></div>
            <div class="tk_box" :class="{'tk_show':floorTkShow}">
                <div class="tk_title">
                    <span class="span1">{{floorTkTitle}}</span>
                    <span class="span2" @click="floorTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        name="file"
                        :data="imgUploadData"
                        :action="actionImgUrl"
                        :on-success="floorFormSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="floorForm.image" :src="floorForm.image" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <img class="phone_icon" src="../img/phone_icon.png" />
                    </el-upload>
                    <p class="img_tips" v-if="floorForm.type == 1">If the picture is uploaded, all floors added will share the same structure chart</p>
                    <div class="form_item">
                        <span class="laber" v-if="domainName != 'plant'">{{$t('App.header.text5')}}</span>
                        <span class="laber" v-if="domainName == 'plant'">{{$t('App.header.text6')}}</span>
                        <el-dropdown @command="commandFormHotel" trigger="click" @visible-change="commandHide('dropdown_hotel_floor_hotel')" v-if="floorFormType == '1'">
                            <span class="span1">{{floorFormHotelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_floor_hotel">
                                <el-dropdown-item v-for="item in hotelNavList" :command="item" :key="'hotel_'+item.id" :class="{'select':item.id == floorForm.hotelId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span v-if="floorFormType == '2'">{{floorFormHotelName}}</span>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.siteManagement.text15')}}</span>
                        <el-dropdown @command="commandFormBuilding" trigger="click" @visible-change="commandHide('dropdown_hotel_floor_build')" v-if="floorFormType == '1'">
                            <span class="span1">{{floorFormBuildingName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_floor_build">
                                <el-dropdown-item v-for="item in floorFormBuildNav" :command="item" :key="'build_'+item.id" :class="{'select':item.id == floorForm.buildId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span v-if="floorFormType == '2'">{{floorFormBuildingName}}</span>
                    </div>
                    <div class="form_item no_bg" v-if="floorFormType == '1'">
                        <el-radio-group v-model="floorForm.type">
                            <el-radio :label="0">{{$t('App.siteManagement.text16')}}</el-radio>
                            <el-radio :label="1">{{$t('App.siteManagement.text17')}}</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="form_item" v-if="floorForm.type == 0">
                        <span class="laber">{{$t('App.floor')}}</span>
                        <!-- <el-input v-model="floorForm.floorId" placeholder=""></el-input> -->
                        <el-dropdown @command="commandFloorFormFloor" trigger="click" @visible-change="commandHide('dropdown_hotel_floor_floor')" v-if="floorFormType == '1'">
                            <span class="span1">{{floorFormFloorStr}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_floor_floor">
                                <el-dropdown-item v-for="item in floorFormFloorList" :command="item" :key="'floor1_'+item.id" :class="{'select':item.id == floorForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span v-if="floorFormType == '2'">{{floorFormFloorStr}}</span>
                    </div>
                    <div class="form_item" v-if="floorForm.type == 1">
                        <span class="laber">{{$t('App.siteManagement.text18')}}</span>
                        <el-dropdown @command="commandFormStart" trigger="click" @visible-change="commandHide('dropdown_hotel_floor_start')">
                            <span class="span1">{{floorFormStartStr}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_floor_start">
                                <el-dropdown-item v-for="item in floorFormFloorList" :command="item" :key="'floor1_'+item.id" :class="{'select':item.id == floorForm.start}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item" v-if="floorForm.type == 1">
                        <span class="laber">{{$t('App.siteManagement.text19')}}</span>
                        <el-dropdown @command="commandFormClose" trigger="click" @visible-change="commandHide('dropdown_hotel_floor_close')">
                            <span class="span1">{{floorFormCloseStr}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_floor_close">
                                <el-dropdown-item v-for="item in floorFormFloorList" :command="item" :key="'floor2_'+item.id" :disabled="item.id<=floorForm.start" :class="{'select':item.id == floorForm.close}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveFloor()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>
        <!-- 添加编辑房间 -->
        <div class="room_wrap tk_wrap scrollbar_style" v-show="roomTkShowbg">
            <div class="tk_wrap_bg" @click="roomTkClose()"></div>
            <div class="tk_box" :class="{'tk_show':roomTkShow}">
                <div class="tk_title">
                    <span class="span1">{{roomTkTitle}}</span>
                    <span class="span2" @click="roomTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        name="file"
                        :data="imgUploadData"
                        :action="actionImgUrl"
                        :on-success="roomFormSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="roomForm.image" :src="roomForm.image" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <img class="phone_icon" src="../img/phone_icon.png" />
                    </el-upload>
                    <div class="form_item">
                        <span class="laber">{{$t('App.siteManagement.text15')}}</span>
                        <el-dropdown @command="commandRoomFormBuild" trigger="click" @visible-change="commandHide('dropdown_hotel_room_build')">
                            <span class="span1">{{roomFormBuildingName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_room_build">
                                <el-dropdown-item v-for="item in roomFormBuildNav" :command="item" :key="'build_'+item.id" :class="{'select':item.id == roomForm.buildId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.floor')}}</span>
                        <el-dropdown @command="commandRoomFormFloor" trigger="click" @visible-change="commandHide('dropdown_hotel_room_floor')">
                            <span class="span1">{{roomFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_room_floor">
                                <el-dropdown-item v-for="item in roomFormFloorNav" :command="item" :key="'build_'+item.id" :class="{'select':item.id == roomForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{hotelType=='1'?$t('App.siteManagement.text21'):$t('App.siteManagement.text22')}}</span>
                        <el-input v-model="roomForm.number" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.siteManagement.text23')}}</span>
                        <el-input v-model="roomForm.sn" placeholder=""></el-input>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveRoom()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>
        <div class="hotel_logo_wrap tk_wrap scrollbar_style" v-show="editHotelLogoShowBg == '1'">
            <div class="tk_wrap_bg" @click="hotelLogoTkClose()"></div>
            <div class="tk_box" :class="{'tk_show':editHotelLogoShow == '1'}">
                <div class="tk_title">
                    <span class="span1">{{$t('App.siteManagement.text24')}}</span>
                    <span class="span2" @click="hotelLogoTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <div class="tabs">
                        <img src="../img/svg/warn_icon.svg"><span>{{$t('App.siteManagement.text25')}}</span>
                    </div>
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        name="file"
                        :data="imgUploadData"
                        :action="actionImgUrl"
                        :on-progress="hotelLogoProgress"
                        :on-change="hotelLogoChange"
                        :on-success="hotelLogoSuccess"
                        :before-upload="beforeAvatarUpload">
                        <span><i class="iconfont icon-shangchuan"></i><span>{{$t('App.siteManagement.text26')}}</span></span>
                    </el-upload>
                    <div class="upload_progress" v-if="uploadHotelLogoStatus == '1'">
                        <div class="l">
                            <div class="i_box">
                                <i class="el-icon-link"></i>
                            </div>
                            <div class="text">
                                {{$t('App.siteManagement.text27')}}
                            </div>
                            <el-progress :percentage="uploadHotelLogoSlider" :show-text="false"></el-progress>
                        </div>
                        <div>{{uploadHotelLogoSlider}}%</div>
                    </div>
                    <div class="success" v-if="uploadHotelLogoStatus == '2'">
                        <div class="box">
                            <div class="l">
                                <div class="i_box">
                                    <i class="el-icon-link"></i>
                                </div>
                                <div class="text1">{{hotelLogoName}}</div>
                                <div class="text2">{{hotelLogoSize}}kb</div>
                            </div>
                            <div class="r"><i class="el-icon-check"></i><span>{{$t('App.siteManagement.text28')}}</span></div>
                        </div>
                        <div class="logo_box">
                            <img :src="hotelLogo">
                        </div>
                    </div>
                    <div class="error" v-if="uploadHotelLogoStatus == '3'">
                        <div class="box">
                            <div class="l">
                                <div class="i_box">
                                    <i class="el-icon-link"></i>
                                </div>
                                <div class="text1">{{hotelLogoName}}</div>
                                <!-- <div class="btn"><i class="el-icon-refresh"></i><span>Re upload</span></div> -->
                            </div>
                            <div class="r"><i class="el-icon-close"></i><span>{{$t('App.siteManagement.text29')}}</span></div>
                        </div>
                        <div class="logo_box">
                            <img :src="hotelLogo">
                        </div>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="updateHotelLogo()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>

        <!-- 添加编辑 -->
        <div class="alarmProfile_wrap scrollbar_style" v-show="alarmProfileTkShowbg">
            <div class="alarmProfile_wrap_bg" @click="alarmProfileTkClose()"></div>
            <div class="alarmProfile_box" :class="{'alarmProfile_tk_show':alarmProfileTkShow}">
                <div class="alarmProfile_title">
                    <span class="span1">{{alarmProfileTkTitle}}</span>
                    <span class="span2" @click="alarmProfileTkClose()">{{$t('App.close')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.siteManagement.text31')}}</span>
                        <!-- <el-input v-model="alarmProfileForm.name" placeholder="Please enter name"></el-input> -->
                        <el-dropdown @command="commandRoomFormalarmProfile" trigger="click" @visible-change="commandHide('dropdown_hotel_room_alarmProfile')">
                            <span class="span1">{{alarmProfileName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_hotel_room_alarmProfile">
                                <el-dropdown-item v-for="item in alarmProfileNav" :command="item" :key="'build_'+item.id" :class="{'select':item.id == alarmProfileForm.id}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveAlarmProfile()">{{$t('App.done')}}</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    export default {
        name:'siteManagement',
        data () {
            return{
                hotelNavList:[],
                hotelId:'',
                hotelType:'',
                hotelForm:{
                    name:'',
                    countryId:'',
                    provinceId:'',
                    cityId:'',
                    longitude:'',
                    latitude:'',
                    avatar:'',
                    logo:'',
                    address:'',
                    type:'',
                },
                hotelTkShowbg:false,
                hotelTkShow:false,
                hotelTitle:'Add hotel',
                countryList:[],
                provinceList:[],
                cityList:[],
                imgUploadData:{
                    username:'',
                    client_key:'',
                    token:'',
                },
                actionImgUrl:'',

                buildId:'',
                buildNav:[],
                buildTkShowbg:false,
                buildTkShow:false,
                buildTkTitle:'',
                buildForm:{
                    hotelId:'',
                    name:'',
                    buildId:'',
                    image:'',
                },

                floorId:'',
                floorStrId:'',
                floorNav:[],
                floorIndex:0,
                floorTkShowbg:false,
                floorTkShow:false,
                floorTkTitle:'',
                floorForm:{
                    id:'',
                    hotelId:'',
                    buildId:'',
                    type:'',
                    floorId:'',
                    start:'',
                    close:'',
                    image:'',
                },
                floorFormType:'1',
                floorFormBuildNav:[],
                floorFormFloorList:[],

                roomList:[],
                roomIdList:[],
                roomTkShow:false,
                roomTkShowbg:false,
                roomTkTitle:'',
                roomForm:{
                    buildId:'',
                    floorId:'',
                    number:'',
                    sn:'',
                    roomId:'',
                    image:'',
                },
                roomFormBuildNav:[],
                roomFormFloorNav:[],

                userId:'',
                userNav:[],
                keywords:'',

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                roomArr:[],
                // activitesArr:['Add equipment','Editing equipment','Delete device','modify state'],

                currentPage:1,
                pageSize:20,
                total:0,

                hotelLogo:'',
                uploadHotelLogoSlider:0,
                uploadHotelLogoStatus:'0',
                hotelLogoName:'',
                hotelLogoSize:0,

                alarmProfileTkTitle:'Setting alarm profile',
                alarmProfileTkShowbg:false,
                alarmProfileTkShow:false,
                alarmProfileForm:{
                    id:'',
                    roomId:'',
                },
                alarmProfileId:'',
                alarmProfileNav:[],

                loading:{
                    roomList:false,
                    buildNav:false,
                    hotelInfo:false,
                },
                
                headerLogo_:'',

                screenMap:'',
                screen:'',
                amapWrapper:false,
                map:null,
                lampLongitude:0,
                lampLatitude:0,

                img_new_hotel:'',
                img_new_building:'',
                img_new_floor:'',
                img_new_room:'',
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',

                // countryId:'countryId',
                // provinceId:'provinceId',
                // cityId:'cityId',
                // hotelId:'hotelId',
                headerUpdate:'headerUpdate',
                headerIdStr:'headerIdStr',
                editHotelLogoShow:'editHotelLogoShow',
                editHotelLogoShowBg:'editHotelLogoShowBg',
                domainName:'domainName'
            }),
            hotelFormCountryName(){
                let name = '';
                for(let d of this.countryList){
                    if(d.id == this.hotelForm.countryId){
                        name = d.name;
                    }
                }
                return name;
            },
            hotelFormProvinceName(){
                let name = '';
                for(let d of this.provinceList){
                    if(d.id == this.hotelForm.provinceId){
                        name = d.name;
                    }
                }
                return name;
            },
            hotelFormCityName(){
                let name = '';
                for(let d of this.cityList){
                    if(d.id == this.hotelForm.cityId){
                        name = d.name;
                    }
                }
                return name;
            },
            buildName(){
                let name = '';
                for(let d of this.buildNav){
                    if(d.id == this.buildId){
                        name = d.name;
                    }
                }
                return name;
            },
            buildFormHotelName(){
                let name = '';
                for(let d of this.hotelNavList){
                    if(d.id == this.buildForm.hotelId){
                        name = d.name;
                    }
                }
                return name;
            },
            floorFormHotelName(){
                let name = '';
                for(let d of this.hotelNavList){
                    if(d.id == this.floorForm.hotelId){
                        name = d.name;
                    }
                }
                return name;
            },
            floorFormBuildingName(){
                let name = '';
                for(let d of this.floorFormBuildNav){
                    if(d.id == this.floorForm.buildId){
                        name = d.name;
                    }
                }
                return name;
            },
            floorFormFloorStr(){
                let name = '';
                for(let d of this.floorFormFloorList){
                    if(d.id == this.floorForm.floorId){
                        name = d.name;
                    }
                }
                return name;
            },
            floorFormStartStr(){
                let name = '';
                for(let d of this.floorFormFloorList){
                    if(d.id == this.floorForm.start){
                        name = d.name;
                    }
                }
                return name;
            },
            floorFormCloseStr(){
                let name = '';
                for(let d of this.floorFormFloorList){
                    if(d.id == this.floorForm.close){
                        name = d.name;
                    }
                }
                return name;
            },
            roomFormBuildingName(){
                let name = '';
                for(let d of this.roomFormBuildNav){
                    if(d.id == this.roomForm.buildId){
                        name = d.name;
                    }
                }
                return name;
            },
            roomFormFloorName(){
                let name = '';
                for(let d of this.roomFormFloorNav){
                    if(d.id == this.roomForm.floorId){
                        name = d.name;
                    }
                }
                return name;
            },
            alarmProfileName(){
                let name = '';
                for(let d of this.alarmProfileNav){
                    if(d.id == this.alarmProfileForm.id){
                        name = d.name;
                    }
                }
                return name;
            },

        },
        components:{
            // 'sideBar':sideBar
        },
        beforeDestroy(){
            this.$store.commit('HEADERLOGO',{
                headerLogo: this.headerLogo_,
            })
        },
        mounted(){
            this.img_new_hotel = require('../img/new_hotel.png');
            this.img_new_building = require('../img/new_building.png');
            this.img_new_floor = require('../img/new_floor.png');
            this.img_new_room = require('../img/new_room.png');
            if(this.version == '1'){
                this.img_new_hotel = require('../img/new_hotel_v1.png');
                this.img_new_building = require('../img/new_building_v1.png');
                this.img_new_floor = require('../img/new_floor_v1.png');
                this.img_new_room = require('../img/new_room_v1.png');
            }
            this.alarmProfileTkTitle = this.$t('App.siteManagement.text30')

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            
            if(this.domainName == 'plant') {
                this.roomArr = [
                {prop:'number',label:this.$t('App.siteManagement.text22'),minWidth:100},
                // {prop:'SN',label:'sn',minWidth:100},
                {prop:'lightCount',label:this.$t('App.dashboard.text32'),minWidth:100},
                {prop:'cicLightCount',label:this.$t('App.dashboard.text59'),minWidth:130},
                {prop:'sensorCount',label:this.$t('App.dashboard.text34'),minWidth:100},
                {prop:'airPurCount',label:this.$t('App.dashboard.text35'),minWidth:120},
            ];
            } else {
                this.roomArr = [
                {prop:'number',label:this.$t('App.siteManagement.text22'),minWidth:100},
                // {prop:'SN',label:'sn',minWidth:100},
                {prop:'lightCount',label:this.$t('App.dashboard.text32'),minWidth:100},
                {prop:'cicLightCount',label:this.$t('App.dashboard.text33'),minWidth:130},
                {prop:'sensorCount',label:this.$t('App.dashboard.text34'),minWidth:100},
                {prop:'airPurCount',label:this.$t('App.dashboard.text35'),minWidth:120},
            ];
            }
            this.imgUploadData.username = this.username;
            this.imgUploadData.client_key = this.client_key;
            this.imgUploadData.token = this.token;
            this.actionImgUrl = allUrl.userManagement.updateFile;

            var storage = window.localStorage;
            this.getHotelNavList(data=>{
                if(data.data.list.length>0){
                    let isHotelId = true;
                    if(storage.getItem('hotelIdNav')){
                        for(let d of data.data.list){
                            if(d.id == storage.getItem('hotelIdNav')){
                                this.hotelId = d.id;
                                this.$store.commit('HEADERLOGO',{
                                    headerLogo: d.logo,
                                })
                                this.headerLogo_ = d.logo;
                                isHotelId = false;
                            }
                        }
                    }
                    if(isHotelId){
                        this.hotelId = data.data.list[0].id;
                        this.$store.commit('HEADERLOGO',{
                            headerLogo: data.data.list[0].logo,
                        })
                        this.headerLogo_ = data.data.list[0].logo;
                    }
                    
                    this.getbuildNav(this.hotelId,data=>{
                        this.buildNav = data.data.list;
                        if(data.data.list.length>0){
                            this.buildId = data.data.list[0].id;
                            this.getfloorNav(this.buildId,data=>{
                                this.floorNav = data.data.list;
                                if(data.data.list.length>0){
                                    this.floorId = data.data.list[0].id;
                                    this.floorStrId = data.data.list[0].floorId;
                                    this.getRoomList()
                                }
                            })
                        }else{
                            this.buildId = '';
                            this.floorNav = '';
                            this.floorId = '';
                            this.floorStrId = '';
                        }
                    })
                }
                let val = '.siteManagement_main .siteManagement_right .siteManagement_right_l .ul';
                this.$nextTick(function(){
                    if($(val)&&$(val+' >.select').offset()){
                        $(val).animate({scrollTop: $(val).scrollTop() + $(val+' >.select').offset().top - $(val).offset().top - 0})
                    }
                })
            });
            for(let i=1;i<101;i++){
                this.floorFormFloorList.push({id:i,name:i+'/F'})
            }
        },
        methods:{
            linkToFun(val){
                this.$router.push({path:val});
                this.$store.commit('ROUTERSTRFUN',{
                    routerStr:val,
                })
            },

            settingRoom(obj){
                this.alarmProfileTkShowbg = true;
                this.$nextTick(function(){
                    this.alarmProfileTkShow = true;
                })
                this.alarmProfileForm.roomId = obj.id;
                this.alarmProfileForm.id = obj.proId;
                this.getAlarmProfileNav()
            },
            alarmProfileTkClose(){
                let this_ = this;
                this.alarmProfileTkShow = false;
                setTimeout(function(){
                    this_.alarmProfileTkShowbg = false;
                },400)
            },
            getAlarmProfileNav(){
                base.ajax_post(
                    allUrl.alarmProfile.getNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.alarmProfileNav = data.data.list;
                    },
                    this
                )
            },
            commandRoomFormalarmProfile(data){
                this.alarmProfileForm.id = data.id;
            },
            postSaveAlarmProfile(){
                let this_ = this;
                base.ajax_post(
                    allUrl.alarmProfile.setRoom,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        ...this.alarmProfileForm,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.alarmProfileTkShow = false;
                        setTimeout(function(){
                            this_.alarmProfileTkShowbg = false;
                        },400)
                        this.getRoomList()
                    },
                    this
                )
            },

            amapWrapperFun(){
                this.lampLongitude = Number(this.hotelForm.longitude);
                this.lampLatitude = Number(this.hotelForm.latitude);
                if(isNaN(this.lampLongitude) || isNaN(this.lampLatitude) || this.lampLongitude>180||this.lampLongitude<-180||this.lampLatitude>90||this.lampLatitude<-90){
                    this.$message({
                      showClose: true,
                      message: this.$t('App.siteManagement.text32'),
                      type: 'warning'
                    });
                }else{
                    let this_ = this;
                    this.amapWrapper = true;
                    this.$nextTick(function(){
                        $('#lampAmapWrapper').css('height',$(window).height()*0.6+'px')
                        // console.log(this.hotelForm)

                        let JDstr = this.$t('App.siteManagement.text12');
                        let WDstr = this.$t('App.siteManagement.text13');
                        let lat = 0;
                        let lng = 0;
                        if(this.version == '0'){
                            if(!isNaN(this.lampLongitude) && !isNaN(this.lampLatitude) &&!(this.lampLongitude ==0 &&this.lampLongitude ==0)){
                                // let bd_decrypt = this.bd_decrypt(this.lampLongitude,this.lampLatitude)
                                this.lampLatitude = Number(this.lampLatitude.toFixed(8));
                                this.lampLongitude = Number(this.lampLongitude.toFixed(8));
                                console.log(this.lampLatitude,this.lampLongitude,'----s')
                                lat = this.lampLatitude;
                                lng = this.lampLongitude;
                                this_.mapDWIsTrue = false;
                                this.map = new google.maps.Map(document.getElementById('lampAmapWrapper'), {
                                    center:{lat: this.lampLatitude, lng: this.lampLongitude},
                                    zoom: 16,
                                    disableDefaultUI: true, //设置为true,禁用地图上所有控件
                                    mapTypeControl: false, //地图类型控制的初始启用/禁用状态。
                                    mapTypeId: google.maps.MapTypeId.ROADMAP, //默认加载道路地图视图  动态设置地图类型
                                    streetViewControl: false,
                                    rotateControl: false,
                                    zoomControl: true,

                                    zoomControlOptions:{
                                        position: google.maps.ControlPosition.RIGHT_BOTTOM,
                                    },
                                    scrollwheel: true,
                                    styles: [
                                        {
                                            "featureType": "poi",
                                            "stylers": [
                                              { "visibility": "off" }
                                            ]
                                        }
                                    ]
                                });
                                // console.log('---------1',lat,lng)
                            }else{
                                this_.mapDWIsTrue = true;
                                this.map = new google.maps.Map(document.getElementById('lampAmapWrapper'), {
                                    center:{lat: 0, lng: 0},
                                    zoom: 16,
                                    gestureHandling: 'greedy',
                                    streetViewControl:false,
                                    mapTypeControlOptions:{
                                      style:google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                                      position:google.maps.ControlPosition.RIGHT_TOP
                                    },
                                    mapTypeId:google.maps.MapTypeId.ROADMAP,
                                });
                            }
                            // console.log(Number(lat),Number(lng))
                            this.geocoder = new google.maps.Geocoder();
                            this_.positionPicker = new RichMarker({
                              position:new google.maps.LatLng(Number(lat),Number(lng)),
                              map: this_.map,
                              draggable: true,
                              content:'<div class="lm_img_mover" style="background-image:url(../img/hotel_1.png);background-position: center;background-size: 100% 100%;width:34px;height:31px;cursor:pointer;"></div>'
                            })
                            if(this_.screenMap && this_.mapDWIsTrue){
                                this_.geocoder.geocode({address:this_.screenMap},function(status, result){
                                    // console.log(status, result)
                                    if(result === 'OK'){
                                        this_.mapDWIsTrue = false;
                                        // lng = status[0].geometry.location.lng();
                                        // lat = status[0].geometry.location.lat();
                                        // console.log(lng,lat)
                                        this_.positionPicker.setPosition(new google.maps.LatLng(lat,lng))
                                        this_.map.setCenter(new google.maps.LatLng(lat,lng));
                                    }else{
                                        this_.mapDWIsTrue = true;
                                        this_.$message({
                                          showClose: true,
                                          message: 'Unrecognized, please change the search content',
                                          type: 'warning'
                                        });
                                    }
                                    function_navigator(this_);
                                })
                            }else{
                                function_navigator(this_);
                            }
                            // console.log(navigator.geolocation , this_.mapDWIsTrue)
                            google.maps.event.addListener(this_.positionPicker,"position_changed",function(){
                                $('.lampLongitude'+this_.lampId).text(this.getPosition().lng().toFixed(8));
                                $('.lampLatitude'+this_.lampId).html(this.getPosition().lat().toFixed(8));
                                this_.lampLongitude = this.getPosition().lng().toFixed(8);
                                this_.lampLatitude = this.getPosition().lat().toFixed(8);
                            })
                            let time = setInterval(function(){
                                if($('.lm_img_mover').length >0){
                                    let div = $('<div class="lamp_coordinate_en lamp_coordinate_'+this_.lampId+'"><span><span>'+ JDstr +' : <span class="lampLongitude'+this_.lampId+'">'+this_.lampLongitude+'</span></span><span>'+ WDstr +' : <span class="lampLatitude'+this_.lampId+'">'+this_.lampLatitude+'</span></span></span><i class="determine_l"></i><i class="cancel_l"></i></div>')
                                    $('.lm_img_mover').parent().append(div);
                                    
                                    $('.lamp_coordinate_'+this_.lampId).children('i').mouseup(function(e){
                                        let className = e.target.className.split(' ');
                                        if(className[0] == 'determine_l'){
                                            this_.hotelForm.longitude = this_.lampLongitude;
                                            this_.hotelForm.latitude = this_.lampLatitude;
                                            $('.lamp_coordinate_'+this_.lampId).css('display','none');
                                            $('.lamp_'+this_.lampId).unbind("mousedown");
                                            this_.amapWrapper = false;
                                        }else if(className[0] == 'cancel_l'){
                                            this_.amapWrapper = false;
                                        }
                                    })
                                    clearInterval(time)
                                }
                            },1)
                        }else{
                            if(!isNaN(this.lampLongitude) && !isNaN(this.lampLatitude)){
                                let bd_decrypt = this.bd_decrypt(this.lampLongitude,this.lampLatitude)
                                this.lampLongitude = bd_decrypt.lat
                                this.lampLatitude = bd_decrypt.lng
                                this.map = new AMap.Map("lampAmapWrapper", {
                                    resizeEnable: true,
                                    center:[this.lampLongitude,this.lampLatitude],
                                    zoom: 18,
                                });
                            }else{
                                this.map = new AMap.Map("lampAmapWrapper", {
                                    resizeEnable: true,
                                    zoom: 18,
                                });
                            }
                            this.geocoder = new AMap.Geocoder({
                            });
                            AMapUI.loadUI(['misc/PositionPicker'], function(PositionPicker) {
                                this_.positionPicker = new PositionPicker({
                                    mode: 'dragMarker',
                                    map: this_.map,
                                     iconStyle: { //自定义外观
                                        url: './img/hotel_1.png',
                                        ancher: [17, 16],
                                        size: [34, 31],
                                    }
                                });

                                this_.positionPicker.on('success', function(positionResult) {
                                    let bd_encrypt = this_.bd_encrypt(positionResult.position.lng,positionResult.position.lat)
                                    console.log(bd_encrypt,bd_encrypt.bd_lng)
                                    positionResult.position.lng = bd_encrypt.bd_lng.toFixed(5);
                                    positionResult.position.lat = bd_encrypt.bd_lat.toFixed(5);

                                    $('.lampLongitude'+this_.lampId).text(positionResult.position.lng);
                                    $('.lampLatitude'+this_.lampId).html(positionResult.position.lat);
                                    
                                    this_.lampLongitude = positionResult.position.lng;
                                    this_.lampLatitude = positionResult.position.lat;
                                });
                                this_.map.addControl(new AMap.ToolBar({
                                    liteStyle: true
                                }))
                                if(this_.lampLongitude && this_.lampLatitude && !(this_.lampLongitude>180||this_.lampLongitude<-180||this_.lampLatitude>90||this_.lampLatitude<-90)){
                                    if(this_.screenMap){
                                        this_.geocoder.getLocation(this_.screenMap, function(status, result) {
                                            if (status === 'complete' && result.info === 'OK') {
                                                if(result.geocodes.length >0){
                                                    this_.positionPicker.start([result.geocodes[0].location.lng,result.geocodes[0].location.lat])
                                                }
                                            }else{
                                                this_.$message({
                                                  showClose: true,
                                                  message: this_.version==0?'无法识别，请更改搜索内容':'Unrecognized, please change the search content',
                                                  type: 'warning'
                                                });
                                                this_.positionPicker.start()
                                            }
                                        });
                                    }else{
                                        this_.map.plugin('AMap.Geolocation', function() {
                                            let geolocation = new AMap.Geolocation({
                                                enableHighAccuracy: true,//是否使用高精度定位，默认:true
                                                timeout: 5000,          //超过10秒后停止定位，默认：无穷大
                                                buttonOffset: new AMap.Pixel(14, 125),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                                                zoomToAccuracy: true,      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                                                buttonPosition:'RB'
                                            });
                                            this_.map.addControl(geolocation);
                                            geolocation.getCurrentPosition();
                                            AMap.event.addListener(geolocation, 'complete', data=>{
                                            //解析定位结果
                                                this_.positionPicker.start([data.position.getLng(),data.position.getLat()])
                                            });//返回定位信息
                                            AMap.event.addListener(geolocation, 'error', ()=>{
                                            //解析定位错误信息
                                                this_.positionPicker.start([114,34]);
                                                this_.$message({
                                                  showClose: true,
                                                  message:this_.version==0?'精确定位失败':'Precision positioning failure',
                                                  type: 'warning'
                                                });
                                            });      //返回定位出错信息
                                        });
                                    }
                                }else{
                                    this_.positionPicker.start([this_.lampLatitude,this_.lampLongitude]);
                                }
                            });
                            let time = setInterval(function(){
                                if($('.amap-marker').children('.amap-marker-content').children('img').parent().length>0){
                                    let div = $('<div class="lamp_coordinate lamp_coordinate_'+this_.lampId+'"><span><span>'+JDstr+' : <span class="lampLongitude'+this_.lampId+'">0</span></span><span>'+WDstr+' : <span class="lampLatitude'+this_.lampId+'">0</span></span></span><i class="determine_l"></i><i class="cancel_l"></i></div>')
                                    $('.amap-marker').children('.amap-marker-content').children('img').parent().append(div);
                                    $('.lampLongitude'+this_.lampId).text(this_.lampLongitude);
                                    $('.lampLatitude'+this_.lampId).html(this_.lampLatitude);
                                    $('.lamp_coordinate_'+this_.lampId).children('i').mousedown(function(){
                                        this_.map.setStatus({'dragEnable':false})
                                    })
                                    $('.lamp_coordinate_'+this_.lampId).children('i').mouseup(function(e){
                                        let className = e.target.className.split(' ');
                                        if(className[0] == 'determine_l'){
                                            console.log(this_.lampLongitude,this_.lampLatitude,'----')
                                            this_.hotelForm.longitude = this_.lampLongitude;
                                            this_.hotelForm.latitude = this_.lampLatitude;
                                            this_.map.setStatus({'dragEnable':true})
                                            $('.lamp_coordinate_'+this_.lampId).css('display','none');
                                            $('.lamp_'+this_.lampId).unbind("mousedown");
                                            this_.positionPicker.stop();
                                            this_.amapWrapper = false;
                                        }else if(className[0] == 'cancel_l'){
                                            this_.positionPicker.stop();
                                            this_.amapWrapper = false;
                                        }
                                    })
                                    clearInterval(time)
                                }
                            },1)
                        }
                    })
                }
                function function_navigator(this_) {
                    if (navigator.geolocation && this_.mapDWIsTrue && this_.googleMapLocattion) {
                        this_.googleMapLocattion = false;
                        let time1 = setInterval(function(){
                            if($('.google_Location').length>0 && $('.google_Location_box .circular').length>0){
                                $('.google_Location').css('display','none');
                                $('.google_Location_box .circular').css('display','inline-block');
                                clearInterval(time1);
                            }
                        },1)
                        let options ={
                            enableHighAccuracy:false,
                            timeout:3000,
                            maximumAge:3000
                        }
                        let successHandler = function(position){
                            this_.map.setCenter(new google.maps.LatLng(position.coords.latitude,position.coords.longitude));
                            // lat = position.coords.latitude;
                            // lng = position.coords.longitude;
                            this_.positionPicker.setPosition(new google.maps.LatLng(position.coords.latitude,position.coords.longitude))
                            this_.googleMapLocattion = true;
                            let time2 = setInterval(function(){
                                if($('.google_Location').length>0 && $('.google_Location_box .circular').length>0){
                                    $('.google_Location').css('display','inline-block');
                                    $('.google_Location_box .circular').css('display','none');
                                    clearInterval(time1);
                                    clearInterval(time2);
                                }
                            },1)
                            // console.log('---------1--------')
                        }
                        let errorHandler = function(){
                            // console.log('------2-----------')
                            this_.googleMapLocattion = true;
                            let time3 = setInterval(function(){
                                if($('.google_Location').length>0 && $('.google_Location_box .circular').length>0){
                                    $('.google_Location').css('display','inline-block');
                                    $('.google_Location_box .circular').css('display','none');
                                    clearInterval(time1);
                                    clearInterval(time3);
                                }
                            },1)
                            this_.$message({
                              showClose: true,
                              message:'seek failed',
                              type: 'warning'
                            });
                        }
                        navigator.geolocation.getCurrentPosition(successHandler,errorHandler,options)
                    }
                }
            },
            screenMapKeyUp(e){
                if(e.key == 'Enter'){
                    this.screenMapChange(this.screenMap);
                }
            },
            screenMapChange(val){
                let this_ = this;
                // console.log(val)
                //地理编码,返回地理编码结果
                this_.geocoder.geocode({address:val},function(status, result){
                    // console.log(status, result)
                    let lng = 0;
                    let lat = 0;
                    if(result === 'OK'){
                        lng = status[0].geometry.location.lng();
                        lat = status[0].geometry.location.lat();
                        console.log(lng,lat)
                        this_.positionPicker.setPosition(new google.maps.LatLng(lat,lng))
                        this_.map.setCenter(new google.maps.LatLng(lat,lng));
                        this_.mapDWIsTrue = false;
                    }else{
                        this_.$message({
                          showClose: true,
                          message: this.$t('App.siteManagement.text33'),
                          type: 'warning'
                        });
                        this_.mapDWIsTrue = true;
                    }
                })
            },
            updateHotelLogo(){
                base.ajax_post(
                    allUrl.siteManagement.updateHotelLogo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                        logo:this.hotelLogo,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.hotelUpdate();
                        this.hotelLogoTkClose();
                    },
                    this,
                    ()=>{
                        let this_ = this;
                        this.$store.commit('EDITHOTELLOGOSHOW',{
                            editHotelLogoShow:'0',
                        })
                        console.log(this.editHotelLogoShow)
                        setTimeout(function(){
                            this_.$store.commit('EDITHOTELLOGOSHOW',{
                                editHotelLogoShowBg:'0',
                            })
                        },600)
                    }
                )
            },
            hotelLogoTkClose(){
                let this_ = this;
                this.$store.commit('EDITHOTELLOGOSHOW',{
                    editHotelLogoShow:'0',
                })
                console.log(this.editHotelLogoShow)
                setTimeout(function(){
                    this_.$store.commit('EDITHOTELLOGOSHOW',{
                        editHotelLogoShowBg:'0',
                    })
                },600)
                this.uploadHotelLogoStatus = '0';
                this.uploadHotelLogoSlider = 0;
                this.hotelLogo = '';
                this.hotelLogoName = '';
                this.hotelLogoSize = 0;
            },
            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            commandbuild(data){
                if(this.buildId!=data.id){
                    this.buildId = data.id;
                    this.getfloorNav(this.buildId,data=>{
                        this.floorNav = data.data.list;
                        if(data.data.list.length>0){
                            this.floorId = data.data.list[0].id;
                            this.floorStrId = data.data.list[0].floorId;
                            this.getRoomList()
                        }
                    })
                }
            },
            commandRoomFormBuild(data){
                this.roomForm.buildId = data.id;
                this.getfloorNav(this.roomForm.buildId,data=>{
                    this.roomFormFloorNav = data.data.list;
                    if(data.data.list.length>0){
                        this.roomForm.floorId = data.data.list[0].id;
                    }
                })
            },
            commandRoomFormFloor(data){
                this.roomForm.floorId = data.id;
            },
            editRoom(obj){
                this.roomTkTitle = this.$t('App.siteManagement.text20');
                this.roomTkShowbg = true;
                this.$nextTick(function(){
                    this.roomTkShow = true;
                })
                this.roomForm.roomId = obj.id;
                base.ajax_post(
                    allUrl.siteManagement.roomInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        roomId:obj.id,
                    },
                    {},
                    obj1=>{
                        for(let key in obj1.data){
                            this.roomForm[key] = obj1.data[key]
                        }
                        this.getbuildNav(this.hotelId,data=>{
                            this.roomFormBuildNav = data.data.list;
                            this.roomForm.buildId = obj1.data.buildId;
                            this.getfloorNav(this.roomForm.buildId,data=>{
                                this.roomFormFloorNav = data.data.list;
                                this.roomForm.floorId = obj1.data.floorId;
                            })
                        })
                    },
                    this
                )
            },
            addRoom(){
                if(this.buildId&&this.floorId){
                    this.roomTkTitle = this.$t('App.siteManagement.text6');
                    this.roomForm.roomId = '';
                    this.roomTkShowbg = true;
                    this.$nextTick(function(){
                        this.roomTkShow = true;
                    })
                    this.roomForm.number = '';
                    this.roomForm.sn = '';

                    this.roomForm.image = '/upload/image/fc0697c804bd70164282fcc0558161a2.png';
                    this.getbuildNav(this.hotelId,data=>{
                        this.roomFormBuildNav = data.data.list;
                        this.roomForm.buildId = this.buildId;
                        this.getfloorNav(this.roomForm.buildId,data=>{
                            this.roomFormFloorNav = data.data.list;
                            this.roomForm.floorId = this.floorId;
                        })
                    })
                }else{
                    this.$message({
                        message: this.$t('App.siteManagement.text34'),
                        type: 'warning'
                    });
                }
            },
            roomTkClose(){
                let this_ = this;
                this.roomTkShow = false;
                setTimeout(function(){
                    this_.roomTkShowbg = false;
                },600)
            },
            postSaveRoom(){
                let this_ = this;
                base.ajax_post(
                    allUrl.siteManagement.saveRoom,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        ...this.roomForm,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.getRoomList();
                        this.roomTkShow = false;
                        setTimeout(function(){
                            this_.roomTkShowbg = false;
                        },600)
                    },
                    this
                )
            },
            delRoom(obj,type){
                let roomId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text23'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(roomId == ''){
                                roomId = id;
                            }else{
                                roomId += ','+id;
                            }
                        }
                    }
                }else{
                    roomId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text32'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.siteManagement.delRoom,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                roomId:roomId,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getRoomList();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },

            commandBuildFormHotel(data){
                this.buildForm.hotelId = data.id;
            },
            addBuild(){
                this.buildForm.buildId = '';
                this.buildForm.name = '';
                this.buildForm.hotelId = this.hotelId;
                this.buildTkShowbg = true;
                this.buildTkTitle = this.$t('App.siteManagement.text4');
                this.$nextTick(function(){
                    this.buildTkShow = true;
                })
            },
            eidtBuild(data){
                this.buildForm.buildId = data.id;
                this.getBuildInfo();
                this.buildForm.name = data.name;
                this.buildForm.hotelId = this.hotelId;
                this.buildTkShowbg = true;
                this.buildTkTitle = this.$t('App.siteManagement.text14');
                this.$nextTick(function(){
                    this.buildTkShow = true;
                    $(".dropdown_hotel_build .el-dropdown-menu__item").click();
                })
            },
            getBuildInfo(){
                base.ajax_post(
                    allUrl.siteManagement.buildInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildForm.buildId,
                    },
                    {},
                    data=>{
                        this.buildForm.image = data.data.image;
                    },
                    this
                )
            },
            buildTkClose(){
                let this_ = this;
                this.buildTkShow = false;
                setTimeout(function(){
                    this_.buildTkShowbg = false;
                },600)
            },
            postSaveBuild(){
                let this_ = this;
                base.ajax_post(
                    allUrl.siteManagement.saveBuild,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        ...this.buildForm,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.getbuildNav(this.hotelId,data=>{
                            this.buildNav = data.data.list;
                            if(data.data.list.length > 0){
                                this.buildId = data.data.list[0].id;
                                this.getfloorNav(this.buildId,data=>{
                                    this.floorNav = data.data.list;
                                    if(data.data.list.length>0){
                                        this.floorId = data.data.list[0].id;
                                        this.floorStrId = data.data.list[0].floorId;
                                        this.getRoomList()
                                    }
                                })
                            }else{
                                this.buildId = '';
                                this.floorNav = '';
                                this.floorId = '';
                                this.floorStrId = '';
                            }
                        })
                        this.buildTkShow = false;
                        setTimeout(function(){
                            this_.buildTkShowbg = false;
                        },600)
                    },
                    this
                )
            },
            postDelBuild(obj){
                // console.log(obj.id)
                let buildId = obj.id;
                this.$confirm(
                    this.$t('App.message.text33'), this.$t('App.message.text17'), {
                        confirmButtonText: this.$t('App.message.text2'),
                        cancelButtonText: this.$t('App.message.text6'),
                        type: 'warning'
                    }
                ).then(() => {
                    base.ajax_post(
                        allUrl.siteManagement.delBuild,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:buildId,
                        },
                        {},
                        data=>{
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                            this.loading.buildNav = true;
                            this.getbuildNav(this.hotelId,data=>{
                                this.loading.buildNav = false;
                                this.buildNav = data.data.list;
                                if(data.data.list.length>0){
                                    this.buildId = data.data.list[0].id;
                                    this.getfloorNav(this.buildId,data=>{
                                        this.floorNav = data.data.list;
                                        if(data.data.list.length>0){
                                            this.floorId = data.data.list[0].id;
                                            this.floorStrId = data.data.list[0].floorId;
                                            this.getRoomList()
                                        }
                                    })
                                }else{
                                    this.buildId = '';
                                    this.floorNav = '';
                                    this.floorId = '';
                                    this.floorStrId = '';
                                }
                            })
                        },
                        this
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('App.message.text18')
                    });          
                });
            },
            /*酒店层级*/
                floorIndexFun(type){
                    if(type == '+'){
                        this.floorIndex++;
                        if(this.floorIndex>parseInt(this.floorNav.length/16)){
                            this.floorIndex = parseInt(this.floorNav.length/16)
                        }
                    }else{
                        this.floorIndex--;
                        if(this.floorIndex<0){
                            this.floorIndex = 0;
                        }
                    }
                },
                commandFormHotel(data){
                    this.floorForm.hotelId = data.id;
                    this.floorForm.buildId = '';
                    this.floorFormBuildNav = [];
                    this.getbuildNav(this.floorForm.hotelId,data=>{
                        this.floorFormBuildNav = data.data.list;
                        if(data.data.list.length>0){
                            this.floorForm.buildId = data.data.list[0].id;
                        }
                    })
                },
                commandFormBuilding(data){
                    this.floorForm.buildId = data.id;
                },
                commandFloorFormFloor(data){
                    // console.log(data)
                    this.floorForm.floorId = data.id;
                },
                commandFormStart(data){
                    this.floorForm.start = data.id;
                },
                commandFormClose(data){
                    this.floorForm.close = data.id;
                },
                addFloor(){
                    if(this.buildId){
                        this.floorFormType = '1';
                        // this.floorId = '';
                        this.floorTkShowbg = true;
                        this.floorTkTitle = this.$t('App.siteManagement.text5');
                        this.$nextTick(function(){
                            this.floorTkShow = true;
                        })
                        this.floorForm.image = '';
                        this.floorForm.type = 1;
                        this.floorForm.start = 1;
                        this.floorForm.close = 2;
                        this.floorForm.floorId = 1;
                        this.floorForm.hotelId = this.hotelId;
                        this.getbuildNav(this.floorForm.hotelId,data=>{
                            this.floorFormBuildNav = data.data.list;
                            this.floorForm.buildId = this.buildId;
                        })
                    }else{
                        this.$message({
                            message: this.$t('App.siteManagement.text35'),
                            type: 'warning'
                        });
                    }
                },
                editFloor(){
                    if(this.floorId){
                        this.floorFormType = '2';
                        this.floorTkShowbg = true;
                        this.floorTkTitle = this.$t('App.siteManagement.text7')
                        this.$nextTick(function(){
                            this.floorTkShow = true;
                        })
                        this.floorForm.image = '';
                        for(let d of this.floorNav){
                            if(d.id == this.floorId){
                                this.floorForm.image = d.image;
                            }
                        }
                        this.floorForm.type = 0;
                        this.floorForm.id = this.floorId;
                        this.floorForm.floorId = this.floorStrId;
                        this.floorForm.hotelId = this.hotelId;
                        this.getbuildNav(this.floorForm.hotelId,data=>{
                            this.floorFormBuildNav = data.data.list;
                            this.floorForm.buildId = this.buildId;
                        })
                    }else{
                        this.$message({
                          showClose: true,
                          message: this.$t('App.message.text23'),
                          type: 'warning'
                        });
                    }
                },
                floorTkClose(){
                    let this_ = this;
                    this.floorTkShow = false;
                    setTimeout(function(){
                        this_.floorTkShowbg = false;
                    },600)
                },
                postSaveFloor(){
                    let this_ = this;
                    if(this.floorFormType == '1'){
                        base.ajax_post(
                            allUrl.siteManagement.saveFloor,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                ...this.floorForm,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getfloorNav(this.buildId,data=>{
                                    this.floorNav = data.data.list;
                                });
                                this.floorTkShowbg = false;
                                setTimeout(function(){
                                    this_.floorTkShowbg = false;
                                },600)
                            },
                            this
                        )
                    }
                    if(this.floorFormType == '2'){
                        base.ajax_post(
                            allUrl.siteManagement.updateFloor,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                id:this.floorForm.id,
                                image:this.floorForm.image,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getfloorNav(this.buildId,data=>{
                                    this.floorNav = data.data.list;
                                });
                                this.floorTkShowbg = false;
                                setTimeout(function(){
                                    this_.floorTkShowbg = false;
                                },600)
                            },
                            this
                        )
                    }

                },
                postDelFloor(){
                    // console.log(obj.id)

                    if(this.floorId){
                        let floorId = this.floorId;
                        this.$confirm(
                            this.$t('App.message.text34'), this.$t('App.message.text17'), {
                                confirmButtonText: this.$t('App.message.text2'),
                                cancelButtonText: this.$t('App.message.text6'),
                                type: 'warning'
                            }
                        ).then(() => {
                            base.ajax_post(
                                allUrl.siteManagement.delFloor,
                                {
                                    username:this.username,
                                    client_key:this.client_key,
                                    token:this.token,
                                    floorId:floorId,
                                },
                                {},
                                data=>{
                                    this.$message({
                                      showClose: true,
                                      message: data.msg,
                                      type: 'success'
                                    });
                                    this.getfloorNav(this.buildId,data=>{
                                        this.floorNav = data.data.list;
                                    });
                                },
                                this
                            )
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: this.$t('App.message.text18')
                            });          
                        });
                    }else{
                        this.$message({
                          showClose: true,
                          message: 'Unchecked',
                          type: 'warning'
                        });
                    }
                },
            /*酒店*/
                commandCountry(data){
                    this.hotelForm.countryId = data.id;
                    this.hotelForm.longitude = data.longitude;
                    this.hotelForm.latitude = data.latitude;
                    this.hotelForm.provinceId = '';
                    this.hotelForm.cityId = '';
                    this.provinceList = [];
                    this.cityList = [];
                    this.getProvince(data1=>{
                        if(data1.data.list.length>0){
                            this.hotelForm.provinceId = data1.data.list[0].id;
                            this.getCity(data=>{
                                if(data.data.list.length>0){
                                    this.hotelForm.cityId = data.data.list[0].id;
                                    this.hotelForm.longitude = data.data.list[0].longitude;
                                    this.hotelForm.latitude = data.data.list[0].latitude;
                                }else{
                                    this.hotelForm.longitude = data1.data.list[0].longitude;
                                    this.hotelForm.latitude = data1.data.list[0].latitude;
                                }
                            })
                        }
                    })
                },
                commandProvince(data){
                    this.hotelForm.provinceId = data.id;
                    this.hotelForm.cityId = '';
                    this.cityList = [];
                    this.getCity(data=>{

                        if(data.data.list.length>0){
                            this.hotelForm.cityId = data.data.list[0].id;
                            this.hotelForm.longitude = data.data.list[0].longitude;
                            this.hotelForm.latitude = data.data.list[0].latitude;
                        }
                    })
                },
                commandCity(data){
                    this.hotelForm.cityId = data.id;
                    this.hotelForm.longitude = data.longitude;
                    this.hotelForm.latitude = data.latitude;
                },
                handleAvatarSuccess(res) {
                    this.hotelForm.avatar = res.data.path;
                },
                buildFormSuccess(res) {
                    this.buildForm.image = res.data.path;
                },
                floorFormSuccess(res) {
                    this.floorForm.image = res.data.path;
                },
                roomFormSuccess(res) {
                    this.roomForm.image = res.data.path;
                },
                logoFormSuccess(res){
                    this.hotelForm.logo = res.data.path;
                },
                hotelLogoSuccess(res){
                    console.log(res)
                    // let this_ = this;
                    // if(res.code == '0000'){
                    //     this.hotelLogo = res.data.path;
                    // }else{
                    //     this.$alert(res.data.error, this.$t('App.message.text1'), {
                    //         confirmButtonText: this.$t('App.message.text2'),
                    //     });
                    //     setTimeout(function(){
                    //     },1000)
                    // }
                },
                hotelLogoChange(res,file){
                    console.log(res,file)
                    let this_ = this;
                    this.hotelLogoName = res.name;
                    this.hotelLogoSize = res.size/1000;
                    if(res.status == 'success'){
                        if(res.response.code == '0000'){
                            this.hotelLogo = res.response.data.path;
                            this.uploadHotelLogoStatus = '2';
                        }else{
                            this.$alert(res.response.data.error, this.$t('App.message.text1'), {
                                confirmButtonText: this.$t('App.message.text2'),
                            });
                            this.uploadHotelLogoStatus = '3';
                        }
                    }else if(res.status== 'ready'){
                        this_.uploadHotelLogoStatus = '0';
                    }else{
                        this_.uploadHotelLogoStatus = '3';
                    }
                },
                hotelLogoProgress(event){
                    console.log(event)
                    this.uploadHotelLogoStatus = '1';
                    this.uploadHotelLogoSlider = parseInt(event.percent);
                },
                beforeAvatarUpload(file) {
                    // console.log(file.type)
                    const isJPG = file.type === 'image/jpeg';
                    const isPNG = file.type === 'image/png';
                    const isLt2M = file.size / 1024 / 1024 < 2;

                    if (!isJPG&&!isPNG) {
                        this.$message.error(this.$t('App.message.text29'));
                    }
                    if (!isLt2M) {
                        this.$message.error(this.$t('App.message.text30'));
                    }
                    return (isJPG||isPNG) && isLt2M;
                },
                hotelSelectFun(data){
                    if(data.id != this.hotelId){
                        this.hotelId = data.id;
                        this.$store.commit('HEADERLOGO',{
                            headerLogo: data.logo,
                        })
                        this.getbuildNav(this.hotelId,data=>{
                            this.buildNav = data.data.list;
                            if(data.data.list.length>0){
                                this.buildId = data.data.list[0].id;
                                this.getfloorNav(this.buildId,data=>{
                                    this.floorNav = data.data.list;
                                    if(data.data.list.length>0){
                                        this.floorId = data.data.list[0].id;
                                        this.floorStrId = data.data.list[0].floorId;
                                        this.getRoomList()
                                    }else{
                                        this.floorId = '';
                                        this.floorStrId = '';
                                        this.roomList = [];
                                    }
                                })
                            }else{
                                this.buildId = '';
                                this.floorNav = [];
                                this.floorId = '';
                                this.floorStrId = '';
                                this.roomList = [];
                            }
                        })
                    }
                },
                floorSelectFun(data){
                    if(this.floorId!=data.id){
                        this.floorId = data.id;
                        this.floorStrId = data.floorId;
                        this.getRoomList();
                    }
                },
                editHotel(obj){
                    this.hotelForm.hotelId = obj.id;
                    this.hotelTkShowbg = true;
                    this.hotelTitle = this.$t('App.siteManagement.text9');
                    this.$nextTick(function(){
                        this.hotelTkShow = true;
                    })
                    this.loading.hotelInfo = true;
                    base.ajax_post(
                        allUrl.siteManagement.hotelInfo,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:obj.id,
                        },
                        {},
                        obj1=>{
                            this.loading.hotelInfo = false;
                            this.hotelForm.avatar = obj1.data.avatar;
                            this.hotelForm.name = obj1.data.name;
                            this.hotelForm.longitude = obj1.data.longitude;
                            this.hotelForm.latitude = obj1.data.latitude;
                            this.hotelForm.logo = obj1.data.logo;
                            this.hotelForm.address = obj1.data.address;
                            this.hotelForm.type = obj1.data.type;
                            if(this.hotelForm.type == 0){
                                this.hotelTitle = this.$t('App.siteManagement.text9');
                            }
                            if(this.hotelForm.type == 1){
                                this.hotelTitle = this.$t('App.siteManagement.text10');
                            }


                            this.getCountry(()=>{
                                this.hotelForm.countryId = obj1.data.countryId;
                                this.getProvince(()=>{
                                    this.hotelForm.provinceId = obj1.data.provinceId;
                                    this.getCity(()=>{
                                        this.hotelForm.cityId = obj1.data.cityId;
                                    })
                                })
                            })
                        },
                        this,()=>{
                            this.loading.hotelInfo = false;
                        }
                    )
                },
                addHotel(type){
                    this.hotelForm.hotelId = '';
                    this.hotelTkShowbg = true;
                    if(type == 0){
                        this.hotelTitle = this.$t('App.siteManagement.text1');
                    }
                    if(type == 1){
                        this.hotelTitle = this.$t('App.siteManagement.text2');
                    }
                    this.$nextTick(function(){
                        this.hotelTkShow = true;
                    })
                    for(let key in this.hotelForm){
                        this.hotelForm[key] = '';
                    }
                    this.hotelForm.type = type;
                    this.provinceList = [];
                    this.cityList = [];
                    this.getCountry(data=>{
                        if(data.data.list.length>0){
                            this.hotelForm.countryId = data.data.list[0].id;
                            this.hotelForm.longitude = data.data.list[0].longitude;
                            this.hotelForm.latitude = data.data.list[0].latitude;
                            this.getProvince(data=>{
                                if(data.data.list.length>0){
                                    this.hotelForm.provinceId = data.data.list[0].id;
                                    this.hotelForm.longitude = data.data.list[0].longitude;
                                    this.hotelForm.latitude = data.data.list[0].latitude;
                                    this.getCity(data=>{
                                        if(data.data.list.length>0){
                                            this.hotelForm.cityId = data.data.list[0].id;
                                            this.hotelForm.longitude = data.data.list[0].longitude;
                                            this.hotelForm.latitude = data.data.list[0].latitude;
                                        }
                                    })
                                }
                            })
                        }
                    })
                },
                hotelTkClose(){
                    let this_ = this;
                    this.hotelTkShow = false;
                    setTimeout(function(){
                        this_.hotelTkShowbg = false;
                    },600)
                },
                postSaveHotel(){
                    if(!this.hotelForm.address){
                        this.$message({
                            message: this.$t('App.siteManagement.text36'),
                            type: 'warning'
                        });
                        return
                    }
                    if(!this.hotelForm.longitude){
                        this.$message({
                            message: this.$t('App.siteManagement.text37'),
                            type: 'warning'
                        });
                        return
                    }
                    if(!this.hotelForm.latitude){
                        this.$message({
                            message: this.$t('App.siteManagement.text38'),
                            type: 'warning'
                        });
                        return
                    }
                    let this_ = this;
                    let cityId = '';
                    if(this.hotelForm.cityId){
                        cityId = this.hotelForm.cityId;
                    }else{
                        if(this.hotelForm.provinceId){
                            cityId = this.hotelForm.provinceId;
                        }else{
                            if(this.hotelForm.countryId){
                                cityId = this.hotelForm.countryId;
                            }
                        }
                    }
                    base.ajax_post(
                        allUrl.siteManagement.saveHotel,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelForm.hotelId,
                            cityId:cityId,
                            name:this.hotelForm.name,
                            longitude:this.hotelForm.longitude,
                            latitude:this.hotelForm.latitude,
                            avatar:this.hotelForm.avatar,
                            address:this.hotelForm.address,
                            type:this.hotelForm.type,
                            // logo:this.hotelForm.logo,
                            // ...this.hotelForm,
                        },
                        {},
                        data=>{
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                            this.hotelUpdate();
                            this.getHotelNavList();
                            this.hotelTkShow = false;
                            setTimeout(function(){
                                this_.hotelTkShowbg = false;
                            },600)
                        },
                        this
                    )
                },
                postDelHotel(obj){
                    let hotelId = obj.id;
                    this.$confirm(
                        this.$t('App.message.text35'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.siteManagement.delHotel,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                hotelId:hotelId,
                            },
                            {},
                            data=>{
                                this.hotelUpdate();
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getHotelNavList(data=>{
                                    if(data.data.list.length>0){
                                        this.hotelId = data.data.list[0].id;
                                        this.$store.commit('HEADERLOGO',{
                                            headerLogo: data.data.list[0].logo,
                                        })
                                        this.getbuildNav(this.hotelId,data=>{
                                            this.buildNav = data.data.list;
                                            if(data.data.list.length>0){
                                                this.buildId = data.data.list[0].id;
                                                this.getfloorNav(this.buildId,data=>{
                                                    this.floorNav = data.data.list;
                                                    if(data.data.list.length>0){
                                                        this.floorId = data.data.list[0].id;
                                                        this.floorStrId = data.data.list[0].floorId;
                                                        this.getRoomList()
                                                    }
                                                })
                                            }
                                        })
                                    }
                                });
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                },
            /**/
            /*酒店侧栏下拉*/
            getHotelNavList(callback){
                base.ajax_post(
                    allUrl.siteManagement.hotelNavList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.hotelNavList = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*添加酒店国家下拉*/
            getCountry(callback){
                base.ajax_post(
                    allUrl.siteManagement.getCountry,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.countryList = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*添加酒店省份下拉*/
            getProvince(callback){
                base.ajax_post(
                    allUrl.siteManagement.getProvince,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        countryId:this.hotelForm.countryId,
                    },
                    {},
                    data=>{
                        this.provinceList = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*添加酒店城市下拉*/
            getCity(callback){
                base.ajax_post(
                    allUrl.siteManagement.getCity,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        provinceId:this.hotelForm.provinceId,
                    },
                    {},
                    data=>{
                        this.cityList = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼房下拉列表*/
            getbuildNav(id,callback){
                base.ajax_post(
                    allUrl.room.buildNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:id,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼层下拉列表*/
            getfloorNav(buildId,callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:buildId,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*房间列表*/
            getRoomList(callback){
                this.loading.roomList = true;
                base.ajax_post(
                    allUrl.siteManagement.roomList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        floorId:this.floorId,
                    },
                    {},
                    data=>{
                        this.loading.roomList = false;
                        this.roomList = data.data.list;
                        
                        this.roomIdList = [];
                        this.checkList = [];
                        this.isIndeterminate = false;
                        this.checkAll = false;
                        for(let d of this.roomList){
                            this.roomIdList.push(d.id);
                        }
                        let i = 1;
                        for(let d of this.roomList){
                            d.webIndex = i;
                            i++;
                        }
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.getLogList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getLogList();
                // console.log(val)
            },
            handleCheckAllChange(val) {
                console.log(val)
                this.checkList = val ? this.roomIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.roomIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.roomIdList.length;
            },
            /*添加删除酒店后更新headerData*/
            hotelUpdate(){
                this.$store.commit('HEADERIDFUN',{
                    headerUpdate: this.headerUpdate+1,
                })
            },
            //百度坐标转高德（传入经度、纬度）
            bd_decrypt(bd_lng, bd_lat) {
                var X_PI = Math.PI * 3000.0 / 180.0;
                var x = bd_lng - 0.0065;
                var y = bd_lat - 0.006;
                var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
                var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
                var gg_lng = z * Math.cos(theta);
                var gg_lat = z * Math.sin(theta);
                return {lng: gg_lng, lat: gg_lat}
            },
            //高德坐标转百度（传入经度、纬度）
            bd_encrypt(gg_lng, gg_lat) {
                var X_PI = Math.PI * 3000.0 / 180.0;
                var x = gg_lng, y = gg_lat;
                var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
                var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
                var bd_lng = z * Math.cos(theta) + 0.0065;
                var bd_lat = z * Math.sin(theta) + 0.006;
                return {
                    bd_lat: bd_lat,
                    bd_lng: bd_lng
                };
            }
        },
        watch:{
            hotelId:function(){
                // console.log(this.hotelId)
                for(let d of  this.hotelNavList){
                    if(d.id == this.hotelId){
                        this.hotelType = d.type;
                    }
                }
                console.log(this.hotelType)
                
                if(this.domainName == 'plant') {
                    this.roomArr = [
                    {prop:'number',label:this.hotelType=='1'?this.$t('App.siteManagement.text21'):this.$t('App.siteManagement.text22'),minWidth:100},
                    // {prop:'SN',label:'sn',minWidth:100},
                    {prop:'lightCount',label:this.$t('App.dashboard.text32'),minWidth:100},
                    {prop:'cicLightCount',label:this.$t('App.dashboard.text59'),minWidth:130},
                    {prop:'sensorCount',label:this.$t('App.dashboard.text34'),minWidth:100},
                    {prop:'airPurCount',label:this.$t('App.dashboard.text35'),minWidth:120},
                ];
                } else {
                    this.roomArr = [
                    {prop:'number',label:this.hotelType=='1'?this.$t('App.siteManagement.text21'):this.$t('App.siteManagement.text22'),minWidth:100},
                    // {prop:'SN',label:'sn',minWidth:100},
                    {prop:'lightCount',label:this.$t('App.dashboard.text32'),minWidth:100},
                    {prop:'cicLightCount',label:this.$t('App.dashboard.text33'),minWidth:130},
                    {prop:'sensorCount',label:this.$t('App.dashboard.text34'),minWidth:100},
                    {prop:'airPurCount',label:this.$t('App.dashboard.text35'),minWidth:120},
                ];
                }
                this.$nextTick(function(){
                    this.$refs.roomList.doLayout();
                })
            },
        }
    }
</script>

<style type="text/css" lang="less">
    .lampAmapWrapper_dialog{
        .el-dialog__body{
            padding:0 1rem 1rem;
        }
        .el-dialog__header{
            padding: 10px 20px 10px;
        }
        .el-dialog__headerbtn{
            top:10px;
        }
    }
    .lamp_coordinate{
        .determine_l{
            background: url(../img/determine-icon.png);
            display:inline-block;
            width: 38px;height: 38px;
        }
        .cancel_l{
            background: url(../img/cancel-icon.png);
            display:inline-block;
            width: 38px;height: 38px;
            margin-left: 10px;
        }
    }
    .lampAmapWrapper_box{
        position: relative;
        .screenMap{
            position: absolute;
            top: 20px;left:40px;
            width:250px;
            z-index: 1;
            line-height: 4rem;
            .el-input__inner{
                height: 4rem;line-height:4rem;
            }
            i{
                // font-size: 2rem;
                cursor: pointer;
            }
        }
        #lampAmapWrapper{
            width: 100%;
            min-height: 400px;
            .google_Location_box{
                width: 40px;
                height: 40px;
                background: #fff;
                right: 10px !important;
                bottom: 120px !important;
                .google_Location{
                    display:none;
                    background: #fff url(http://webapi.amap.com/theme/v1.3/markers/b/loc_gray.png) 50% 50% no-repeat;
                    width: 38px;
                    height: 38px;
                    border: 1px solid #ccc;
                    cursor: pointer;
                }
                .circular{
                    height: 40px;
                    width: 40px;
                    animation: loading-rotate 2s linear infinite;
                    .path{
                        animation: loading-dash 1.5s ease-in-out infinite;
                        stroke-dasharray: 90,150;
                        stroke-dashoffset: 0;
                        stroke-width: 2;
                        stroke: #409eff;
                        stroke-linecap: round;
                    }
                }
            }
            .lamp_coordinate_en{
                // width: 200px
                // display: none;
                position: absolute;
                line-height: 30px;
                width: 600px;
                top: -2px;
                left: 50px;
                display: flex;
                align-items: center;
                >span{
                    display: inline-block;
                    padding: 0 20px;
                    margin-right: 20px;
                    font-size: 14px;
                    color: #888888;
                    background: #fff;
                    span{
                        span{
                            color:#fc8440;
                        }
                    }
                    >:first-child{
                        margin-right: 10px;
                    }
                }
                .determine_l{
                    background-image: url(../img/determine-icon.png);
                    background-size: 100% 100%;background-position: center;
                    display:inline-block;
                    width: 30px;height: 30px;
                }
                .cancel_l{
                    background-image: url(../img/cancel-icon.png);
                    background-size: 100% 100%;background-position: center;
                    display:inline-block;
                    width: 30px;height: 30px;
                    margin-left: 10px;
                }
            }
            .lamp_coordinate{
                // width: 200px
                // display: none;
                position: absolute;
                line-height: 40px;
                width: 450px;
                top: -8px;
                left: 50px;
                display: flex;
                align-items: center;
                >span{
                    display: inline-block;
                    padding: 0 20px;
                    margin-right: 20px;
                    font-size: 14px;
                    color: #888888;
                    background: #fff;
                    span{
                        span{
                            color:#fc8440;
                        }
                    }
                    >:first-child{
                        margin-right: 10px;
                    }
                }
                >i{
                    font-size:30px;
                    z-index: 1;
                    cursor: pointer;
                }
            }
        }
    }
    .siteManagement_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .siteManagement_right .siteManagement_right_l .ul .li.select .border{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
            .siteManagement_right .siteManagement_right_main .main_top .div2 .ul .li.select{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
            .siteManagement_right .siteManagement_right_main .main_top .div3 .div3_r .btn i{
                color: #8266C7;
            }
            .siteManagement_right .siteManagement_right_main .main_cont .el-table .btn:hover i{
                color: #8266C7;
            }
            .tk_wrap .tk_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
            .alarmProfile_wrap .alarmProfile_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
        }
        .siteManagement_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .siteManagement_right{
            position: relative;
            // padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            display: flex;
            .btn{
                img{
                    margin-right: 0.8rem;
                    height: 0.8rem;
                }
            }
            .siteManagement_right_l{
                background-color:rgba(246, 248, 250, 1);
                padding: 0 0.5rem 0 1.67rem;
                width: 21.6rem;
                height: calc(100%);
                .btn_box{
                    display: flex;
                    margin-top: 1.67rem;
                    .btn{
                        cursor: pointer;
                        text-align: center;
                        width:9.5rem;
                        height:2.5rem;line-height: 2.5rem;
                        background:rgba(255,255,255,1);
                        border-radius:1.25rem;
                        border:0.08rem solid rgba(240,240,240,1);
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                    }
                }
                .ul{
                    margin-top: 1.67rem;
                    margin-right: 0;
                    padding-right: 0.5rem;
                    height: calc(100% - 6.5rem);
                    &.scrollbar_style_show::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                        background: #f6f8fa;
                    }
                    .li{
                        width:calc(100% - 0.3rem);
                        height:10.67rem;
                        background:rgba(255,255,255,1);
                        position: relative;
                        cursor: pointer;
                        &.select{
                            cursor: initial;
                            box-shadow:0rem 0.17rem 1rem 0rem rgba(0,0,0,0.05);
                            .border{
                                position: absolute;
                                left: 0;top: 1.67rem;
                                width:0.17rem;
                                height:1.42rem;
                                background:rgba(5,207,171,1);
                            }
                            .li_box1{
                                .li_box1_l{
                                    display: flex;
                                    width: calc(100% - 4rem);
                                }
                            }
                        }
                        border-radius:0.5rem;
                        padding: 1.17rem 0 0 0;
                        margin-bottom: 0.83rem;
                        .li_box1{
                            display: flex;
                            justify-content: space-between;
                            // align-items: center;
                            height: 2.4rem;line-height: 2.4rem;
                            padding: 0 1.17rem;
                            .li_box1_l{
                                display: flex;
                                width: 100%;
                            }
                            .img_box{
                                width:2.33rem;height: 2.33rem;
                                border-radius: 50%;
                                overflow: hidden;
                                img{
                                    width: 100%;height: 100%;
                                }
                            }
                            .text_box{
                                width: calc(100% - 3.1rem);
                                margin-left: 0.67rem;
                                text-align: left;
                                font-size:1.17rem;
                                font-family:AlibabaPuHuiTiR;
                                font-weight:500;
                                color:rgba(51,51,51,1);
                                span{
                                    display: inline-block;
                                    width: 100%;
                                    overflow: hidden;
                                    text-overflow:ellipsis;
                                    white-space: nowrap;
                                }
                            }
                            .icon_box{
                                .iconfont{
                                    margin-left: 0.5rem;
                                    cursor: pointer;
                                    padding: 0.3rem;
                                    font-size: 0.75rem;
                                }
                                color: rgba(198, 205, 213, 1);
                            }
                        }
                        .li_box2{
                            height: 4.4rem;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(101,112,133,1);
                            line-height:1.17rem;
                            padding: 1rem 1.17rem;
                            p{
                                // word-break: break-all;
                            }
                        }
                        .li_box3{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            border-top:1px solid rgba(235, 239, 242, 1);
                            padding: 0 1.17rem;
                            height: 2.67rem;line-height: 2.67rem;
                            .li_box3_l{
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiL;
                                color:rgba(51,51,51,1);
                            }
                            .li_box3_r{
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(51,51,51,1);
                            }
                        }
                    }
                }
            }
            .siteManagement_right_main{
                width: calc(100% - 21.6rem);
                height: 100%;
                position: relative;
                background: #FFFFFF;
                border-left: 1px solid #F0F0F0;
                .main_top{
                    width: 100%;
                    padding: 0 1.67rem 0;
                    margin-top: 1.67rem;
                    .div1{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .el-dropdown{
                            cursor: pointer;
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                        }
                        .div1_r{
                            display: flex;
                            .btn{
                                cursor: pointer;
                                margin-left: 0.83rem;
                                padding: 0 1rem;
                                height:2.5rem;line-height: 2.5rem;
                                background:rgba(255,255,255,1);
                                border-radius:1.25rem;
                                border:0.08rem solid rgba(240,240,240,1);
                            }
                        }
                    }
                    .div2{
                        margin-top: 1.67rem;
                        height:2.5rem;line-height: 2.5rem;
                        background:rgba(246,248,250,1);
                        border-radius:1.38rem;
                        position: relative;
                        .ul_box{
                            overflow: hidden;
                            width:calc(100% - 3rem);
                        }
                        &.hide_left_btn{
                            .ul_box{
                                margin-left: 3rem;
                                width:calc(100% - 6rem);
                            }
                        }
                        .ul{
                            position: relative;
                            display: flex;
                            // transition: all 0.8s;
                            .li{
                                width: 6.25%;
                                min-width: 6.25%;
                                text-align:center;
                                cursor: pointer;
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(51,51,51,1);
                                &.select{
                                    border-radius:1.67rem;
                                    background-color:rgba(5, 207, 171, 1);
                                    color:rgba(255,255,255,1);
                                    cursor: initial;
                                    .iconfont{
                                        cursor: pointer;
                                        margin-left: 0.2rem;
                                        padding: 0.2rem;
                                        font-size: 0.75rem;
                                    }
                                }
                            }
                        }
                        .l_btn{
                            text-align:center;
                            cursor: pointer;
                            position: absolute;
                            left: 0rem;top: 0;
                            width: 3rem;
                            height:2.5rem;line-height: 2.5rem;
                            background:rgba(235,239,242,1);
                            border-radius: 1.38rem 0rem 0rem 1.38rem;
                            i{
                                color:rgba(101, 112, 133, 1);
                            }
                        }
                        .r_btn{
                            text-align:center;
                            cursor: pointer;
                            position: absolute;
                            right: 0rem;top: 0;
                            width: 3rem;
                            height:2.5rem;line-height: 2.5rem;
                            background:rgba(235,239,242,1);
                            border-radius:0rem 1.38rem 1.38rem 0rem;
                            i{
                                color:rgba(101, 112, 133, 1);
                            }
                        }
                        // margin: 0 1.75rem 0 1.65rem; 
                    }
                    .div3{
                        margin-top: 1.33rem;
                        display: flex;
                        justify-content: space-between;
                        .div3_l{
                            display: flex;
                            align-items: center;
                            .btn{
                                margin-left: 1.29rem;
                                display: flex;align-items: center;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                cursor: pointer;
                                i{
                                    font-size:0.8rem;
                                    color: #C6CDD5;
                                }
                                span{
                                    margin-left: 0.5rem;
                                }
                            }
                        }
                        .div3_r{
                            display: flex;
                            .btn{
                                cursor: pointer;
                                margin-left: 0.83rem;
                                padding: 0 1rem;
                                height:2.5rem;line-height: 2.5rem;
                                background:rgba(255,255,255,1);
                                border-radius:1.25rem;
                                border:0.08rem solid rgba(240,240,240,1);
                                i{
                                    margin-right: 0.58rem;
                                    font-size: 1.1rem;
                                    color: #05cfab;
                                }
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 14rem);
                    margin-top: 0.75rem;
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        width: calc(100% - 3.6rem);
                        border:0.08rem solid rgba(240,240,240,1);
                        margin: 0 1.8rem;
                        .el-checkbox{
                            margin-left: 1.1rem;
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .activites{
                            .text_0{
                                color: #05CFAB;
                            }
                            .text_1{
                                color: #0A82CF;
                            }
                            .text_2{
                                color: #FF0C4D;
                            }
                            .text_3{
                                color: #0A82CF;
                            }
                        }
                    }
                    .pagination_box{
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .tk_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .tk_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            &.hotel_wrap{
                .tk_box,.tk_wrap_bg{
                    min-height: 64rem;
                }
                .form{
                    .avatar-uploader {
                        margin-bottom: 2rem;
                        .el-upload {
                            border: 1px solid #EBEFF2;
                            width: 8.33rem;
                            display: block;
                            margin: 0 auto;
                            cursor: pointer;
                            position: relative;
                            border-radius: 50%;
                            // overflow: hidden;
                            // &:hover {
                            //  border-color: #409EFF;
                            // }
                            .avatar-uploader-icon {
                                font-size: 28px;
                                color: #8c939d;
                                width: 8.33rem;
                                height: 8.33rem;
                                line-height: 8.33rem;
                                text-align: center;
                            }
                            .avatar {
                                width: 8.33rem;
                                height: 8.33rem;
                                display: block;
                                overflow: hidden;
                                border-radius: 50%;
                            }
                            .phone_icon{
                                position: absolute;
                                width: 2.33rem;height: 2.33rem;
                                right: 0;bottom: 0;
                            }
                        }
                    }
                    .avatar-uploader_w {
                        margin-bottom: 2rem;
                        .el-upload {
                            border: 1px solid #EBEFF2;
                            width: 10rem;
                            display: block;
                            margin: 0 auto;
                            cursor: pointer;
                            position: relative;
                            border-radius: 0.4rem;
                            // overflow: hidden;
                            // &:hover {
                            //  border-color: #409EFF;
                            // }
                            .avatar-uploader-icon {
                                font-size: 28px;
                                color: #8c939d;
                                width: 10rem;
                                height: 3rem;
                                line-height: 3rem;
                                text-align: center;
                            }
                            .avatar {
                                width: 10rem;
                                height: 3rem;
                                display: block;
                                overflow: hidden;
                                border-radius: 0.4rem;
                            }
                            .phone_icon{
                                position: absolute;
                                width: 2.33rem;height: 2.33rem;
                                right: 0;bottom: 0;
                            }
                        }
                    }
                }
                .location{
                    position: absolute;
                    top: -3.2rem;right: -5.5rem;
                    width: 4rem;height: 4rem;line-height:4rem;
                    border: 1px solid #fff;
                    text-align: center;
                    cursor: pointer;
                    &:hover{
                        border-color:#05CFAB;
                    }
                    i{
                        font-size: 2.5rem;
                        color:#05CFAB;
                    }
                }
            }
            &.build_wrap,&.room_wrap{
                .form{
                    .avatar-uploader {
                        margin-bottom: 2rem;
                        .el-upload {
                            width: 8.33rem;
                            display: block;
                            margin: 0 auto;
                            cursor: pointer;
                            position: relative;
                            border: 1px solid #EBEFF2;
                            border-radius: 0.4rem;
                            .avatar-uploader-icon {
                                font-size: 28px;
                                color: #8c939d;
                                width: 8.33rem;
                                height: 8.33rem;
                                line-height: 8.33rem;
                                text-align: center;
                            }
                            .avatar {
                                width: 8.33rem;
                                height: 8.33rem;
                                display: block;
                                overflow: hidden;
                                border-radius: 0.4rem;
                            }
                            .phone_icon{
                                position: absolute;
                                width: 2.33rem;height: 2.33rem;
                                right: 0;bottom: 0;
                            }
                        }
                    }
                }
            }
            &.floor_wrap{
                .form{
                    .avatar-uploader {
                        margin-bottom: 1rem;
                        .el-upload {
                            width: 8.33rem;
                            display: block;
                            margin: 0 auto;
                            cursor: pointer;
                            position: relative;
                            border: 1px solid #EBEFF2;
                            border-radius: 0.4rem;
                            .avatar-uploader-icon {
                                font-size: 28px;
                                color: #8c939d;
                                width: 8.33rem;
                                height: 8.33rem;
                                line-height: 8.33rem;
                                text-align: center;
                            }
                            .avatar {
                                width: 8.33rem;
                                height: 8.33rem;
                                display: block;
                                overflow: hidden;
                                border-radius: 0.4rem;
                            }
                            .phone_icon{
                                position: absolute;
                                width: 2.33rem;height: 2.33rem;
                                right: 0;bottom: 0;
                            }
                        }
                    }
                    .img_tips{
                        margin: 0 2.5rem;
                        background:rgba(255,12,77,0.1);
                        text-align:center;
                        margin-bottom: 1rem;
                        font-size:0.8rem;
                        height: 2rem;line-height: 2rem;
                        font-family:AlibabaPuHuiTiR;
                        color:rgba(255,12,77,1);
                    }
                }
            }
            .tk_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.8s;
                &.tk_show{
                    right: 0rem; 
                }
                .tk_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        &.no_bg{
                            background-color:initial;
                        }
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
            &.hotel_logo_wrap{
                .tabs{
                    position: relative;
                    text-align: center;
                    width:calc(100% - 5rem);
                    height:3.33rem;line-height: 3.33rem;
                    margin: 0 2.5rem;
                    background:rgba(255,12,77,0.1);

                    font-size:1rem;
                    font-family:PingFang-SC-Medium,PingFang-SC;
                    font-weight:500;
                    color:rgba(255,12,77,1);
                    img{
                        height: 1rem;
                        margin-right:1rem;
                    }
                }
                .avatar-uploader{
                    width:calc(100% - 5rem);
                    margin: 1.67rem auto 0;
                    height:7rem;line-height: 7rem;
                    background:rgba(246,248,247,1);
                    border:0.08rem dashed rgba(101,112,133,0.5);
                    .el-upload{
                        text-align: center;
                        width: 100%;height: 100%;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(119,130,151,1);
                        .icon-shangchuan{
                            font-size: 1.2rem;
                            margin-right: 0.83rem;
                        }
                    }
                }
                .upload_progress{
                    width:calc(100% - 5rem);
                    margin: 1.67rem auto 0;
                    display: flex;
                    justify-content: space-between;
                    .l{
                        display: flex;
                    }
                    .i_box{
                        margin-right: 0.5rem;
                        width:1.5rem;text-align: center;
                        height:1.5rem;line-height: 1.5rem;
                        border-radius: 50%;
                        background:rgba(235,239,242,1);
                        color: rgba(198, 205, 213, 1);
                    }
                    .text{
                        margin-right: 2rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                    }
                    .el-progress{
                        width: 16rem;height: 2rem;line-height: 2rem;
                        .el-progress-bar{
                            margin-top: 0.4rem;
                        }
                    }
                }
                .success{
                    .box{
                        width:calc(100% - 5rem);
                        margin: 1.67rem auto 0;
                        display: flex;
                        justify-content: space-between;
                        .l{
                            display: flex;
                        }
                        .i_box{
                            margin-right: 0.5rem;
                            width:1.5rem;text-align: center;
                            height:1.5rem;line-height: 1.5rem;
                            border-radius: 50%;
                            background:rgba(118, 178, 148, 0.1);
                            color: rgba(5, 207, 171, 1);
                        }
                        .text1{
                            margin-right: 2rem;
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                            max-width: 12rem;
                            display: inline-block;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .text2{
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(101,112,133,1);
                        }
                        .r{
                            i{
                                margin-right: 0.5rem;
                                display: inline-block;
                                text-align: center;
                                width: 1.3rem;height: 1.3rem;line-height: 1.3rem;
                                border-radius:50%;
                                color: #FFFFFF;
                                background-color:rgba(5, 207, 171, 1);
                            }
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                        }
                    }
                    .logo_box{
                        width:calc(100% - 5rem);
                        margin: 1.67rem auto 0;
                        img{
                            margin-left: 2rem;
                            height: 1.4rem;
                        }
                    }
                }
                .error{
                    .box{
                        width:calc(100% - 5rem);
                        margin: 1.67rem auto 0;
                        display: flex;
                        justify-content: space-between;
                        .l{
                            display: flex;
                        }
                        .i_box{
                            margin-right: 0.5rem;
                            width:1.5rem;text-align: center;
                            height:1.5rem;line-height: 1.5rem;
                            border-radius: 50%;
                            background:rgba(255, 12, 77, 0.1);
                            color: rgba(255, 12, 77, 1);
                        }
                        .text1{
                            margin-right: 2rem;
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                            max-width: 14rem;
                            display: inline-block;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .r{
                            i{
                                margin-right: 0.5rem;
                                display: inline-block;
                                text-align: center;
                                width: 1.3rem;height: 1.3rem;line-height: 1.3rem;
                                border-radius:50%;
                                color: #FFFFFF;
                                background-color:rgba(255, 12, 77, 1);
                            }
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                        }
                    }
                }
            }
        }
        .alarmProfile_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .alarmProfile_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 30rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .alarmProfile_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 30rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.alarmProfile_tk_show{
                    right: 0rem; 
                }
                .alarmProfile_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
    .dropdown_hotel_build{
        .el-dropdown-menu__item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 10px 0 20px;
            &.select{
                cursor: initial;
            }
            .iconfont{
                color: #ccc;
                cursor: pointer;
                margin: 0 0 0 0.5rem;
                padding: 0.5rem;
                font-size: 0.8rem;
            }
        }
    }
</style>